import * as Constants from "../constants";

const GET_PUBLISHED_FQ = () => {
  let fq:string = "&fq=published:true";  //default is only show published

  /* todo: jain - publishedOnly comes from "${grailsApplication.config.publishedOnly}"; */
  /* let publishedOnly:string = PUBLISHED_ONLY.toLowerCase();
  if (publishedOnly.charAt(0) == 'f') {// if user passes in f, then remove the fq
    fq = "";
  }*/

  return fq;
}

export const BrowseQuery = (collectionCode: string[], rows: number, dir: string, docIdInt: number ): string => {
  let query: string = "q=*:*";
  query += "&fq=(collectioncode:\"" + collectionCode.join("\" OR collectioncode:\"") + "\")";
  query += GET_PUBLISHED_FQ()
  query += "&fl=id,id_int,tid,au,ti,bn,dt,dd,availability,pg,attach,access,artifact,collection,industry";
  query += "&wt=json";
  query += "&indent=true";
  query += "&rows=" + rows;

  switch (dir) {
    case Constants.PREV:
      query += "&fq=id_int:[* TO " + docIdInt + "}";
      query += "&sort=id_int desc";
      break;

    case  Constants.NEXT:
      query += "&fq=id_int:{" + docIdInt + " TO *]";
      query += "&sort=id_int asc";
      break;

    default:
  }
  return query;
}
